// extracted by mini-css-extract-plugin
export default {"hyperlink":"EditorExtension_AlbumViewer_hyperlink__Iq-gY"};